import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'loi-lti-common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(private gtmService: GoogleTagManagerService) {
  }
  ngOnInit(): void {
    console.info('Adding Google Tag Manager to DOM');
    this.gtmService.addGtmToDom();
  }
}
